import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

// API services
import { useDeleteLeaveCreditRequest } from 'services/api/modules/leave/leaveRequest'
import AdxButton from 'components/custom/AdxButton'

const WithdrawRequestWarning = ({ sx }) => {
  const params = useParams()
  const mutation = useDeleteLeaveCreditRequest()
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  return (
    <>
      <AdxButton variant={'outlined'} onClick={handleOpen} sx={{ width: '100%', ...sx }}>
        Withdraw
      </AdxButton>
      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="warning.main"
        title="Withdraw Request?"
        subtitle="Are you sure to withdraw this application?"
        footerButtons
        firstBtnLabel="Confirm"
        firstBtnHandle={() =>
          mutation.mutate(params.id, {
            onSuccess: () => {
              handleClose()
            },
          })
        }
        secondBtnLabel="Cancel"
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}

export default WithdrawRequestWarning
